export const orderStats = `
query MyQuery($type: PeriodType = DAILY, $status: StatOrderStatusType = ALL) {
  orderStats(status: $status, type: $type) {
    count
    label
  }
}
`